export const RISK_LEVELS = {
    HIGH_RISK: {
        value: 'HIGH_RISK',
        label: 'High'
    },
    MEDIUM_RISK: {
        value: 'MEDIUM_RISK',
        label: 'Medium'
    },
    LOW_RISK: {
        value: 'LOW_RISK',
        label: 'Low'
    },
    NOT_APPLICABLE: {
        value: 'NOT_APPLICABLE',
        label: 'Not Applicable'
    }
};

export const RISK_CATEGORIES = {
    overall: {
        label: 'Overall',
        value: 'OVERALL'
    },
    academic: {
        label: 'Academic',
        value: 'ACADEMIC'
    },
    financial: {
        label: 'Financial',
        value: 'FINANCIAL'
    },
    engagement: {
        label: 'Engagement',
        value: 'ENGAGEMENT'
    },
    wellness: {
        label: 'Wellness',
        value: 'WELLNESS'
    }
};

export const RISK_SUB_DRIVERS = [
    // Academic
    {
        name: 'Perceived Course Relevance',
        id: 'academicPerceivedCourseRelevance',
        parent: 'academic'
    },
    { name: 'Technical Hurdles', id: 'academicTechnicalHurdles', parent: 'academic' },
    { name: 'Course Engagement', id: 'academicCourseEngagement', parent: 'academic' },
    { name: 'Perceived Course Quality', id: 'academicPerceivedCourseQuality', parent: 'academic' },
    { name: 'Self-Efficacy', id: 'academicSelfEfficacy', parent: 'academic' },
    { name: 'Instructor Relationship', id: 'academicInstructorRelationship', parent: 'academic' },
    { name: 'Online Learning', id: 'academicOnlineLearning', parent: 'academic' },
    { name: 'Career Readiness', id: 'academicCareerReadiness', parent: 'academic' },
    { name: 'Diligence', id: 'academicDiligence', parent: 'academic' },
    { name: 'Overall Perception', id: 'academicOverallPerception', parent: 'academic' },

    // Engagement
    { name: 'Morale', id: 'engagementMorale', parent: 'engagement' },
    { name: 'Commitment to Persist', id: 'engagementCommitmentToPersist', parent: 'engagement' },
    {
        name: 'Satisfaction with Institution',
        id: 'engagementSatisfactionWithInstitution',
        parent: 'engagement'
    },
    { name: 'Support System', id: 'engagementSupportSystem', parent: 'engagement' },
    { name: 'Sense of Belonging', id: 'engagementSenseOfBelonging', parent: 'engagement' },
    { name: 'Social Engagement', id: 'engagementSocialEngagement', parent: 'engagement' },
    { name: 'Overall Perception', id: 'engagementOverallPerception', parent: 'engagement' },
    { name: 'Perceived D&I', id: 'engagementPerceivedDI', parent: 'engagement' },

    // Financial
    { name: 'Financial Means', id: 'financialFinancialMeans', parent: 'financial' },
    { name: 'Tuition', id: 'financialTuition', parent: 'financial' },
    { name: 'Overall Perception', id: 'financialOverallPerception', parent: 'financial' },
    { name: 'Balancing Work & School', id: 'financialBalancingWorkAndSchool', parent: 'financial' },
    {
        name: 'Housing and Food Insecurity',
        id: 'financialHousingAndFoodInsecurity',
        parent: 'financial'
    },
    {
        name: 'Supporting Family Member',
        id: 'financialSupportingFamilyMember',
        parent: 'financial'
    },

    // Wellness
    { name: 'Stress', id: 'wellnessStress', parent: 'wellness' },
    { name: 'Roommate Relationship', id: 'wellnessRoommateRelationship', parent: 'wellness' },
    { name: 'Overall Perception', id: 'wellnessOverallPerception', parent: 'wellness' },
    { name: 'Parental Stress', id: 'wellnessParentalStress', parent: 'wellness' },
    { name: 'Housing Satisfaction', id: 'wellnessHousingSatisfaction', parent: 'wellness' },
    { name: 'Homesickness', id: 'wellnessHomesickness', parent: 'wellness' },
    { name: 'Lifestyle', id: 'wellnessLifestyle', parent: 'wellness' },
    { name: 'Time Management', id: 'wellnessTimeManagement', parent: 'wellness' },
    { name: 'Mental & Physical Health', id: 'wellnessMentalAndPhysicalHealth', parent: 'wellness' }
];
